export default (id: string, offset?: number) => {
  const matchingSection = document.getElementById(id);
  if (!matchingSection) return;

  const sectionPosition = matchingSection.getBoundingClientRect();
  let sectionYPosition = sectionPosition.top + window.scrollY;

  if (offset) {
    sectionYPosition = sectionYPosition - offset;
  }

  window.scrollTo({
    top: sectionYPosition,
    behavior: 'smooth',
  });
};
